import { useTranslation } from 'react-i18next'

export function CallbackPage() {
  const { t } = useTranslation()

  return <div className="flex h-screen items-center justify-center">{t('callback.signingIn')}</div>
}
